import { render } from "./HorizentalView.vue?vue&type=template&id=547e74e8&scoped=true"
import script from "./HorizentalView.vue?vue&type=script&lang=js"
export * from "./HorizentalView.vue?vue&type=script&lang=js"

import "./HorizentalView.vue?vue&type=style&index=0&id=547e74e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547e74e8"]])

export default __exports__